import React from "react";
import OrdersIconSvg from "./Orders.svg?react";

export default function Orders() {
	return (
		<div>
			<OrdersIconSvg />
		</div>
	);
}
